<button [type]="type"
  [disabled]="disabled"
  [class.disabled]="disabled"
  [class.shadow-effect]="shadowEffect"
  [ngClass]="['mp-button', shape + '-shape', size + '-size', color, 'icon-' + faIconPosition, customClasses]"
  (click)="sendButtonClicked($event)">
  <i *ngIf="faIcon" class="mp-button-icon {{faIcon}}"></i>
  <span class="mp-button-label" *ngIf="label">{{ label | translate }}</span>
  <div class="loader" *ngIf="isLoading">
    <i class="fas fa-spin fa-circle-notch"></i>
  </div>
</button>

